module.exports = __webpack_public_path__ + "static/img/1958_10_MusicalAmerica_DarmstadtReview_1.317aadb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_10_MusicalAmerica_DarmstadtReview_1.jpg
// module id = 2pWh
// module chunks = 0